import api from "../utils/api";
import { Category } from "../types";

export const getCategories = async (): Promise<Category[]> => {
  const response = await api.get("/categories?showInactive=false");
  return response.data;
};
